// Favorites — the per-device list of players a user follows. Stored in localStorage so it works
// with zero setup, and best-effort synced into the push WATCHLIST so the existing alert engine
// (notify_watchlist_thresholds) pings them when they hit a featured play / line move. No push yet?
// It still saves locally; call syncFavsNow() after they enable alerts to push the list up.
import { getPushEndpoint, getNFLNotifyPrefs, setNFLNotifyPrefs } from './api'

const KEY = 'brkr_nfl_favs'

export function getFavs() {
  try { return JSON.parse(localStorage.getItem(KEY)) || {} } catch (_) { return {} }
}
export function isFav(gsis) { return !!getFavs()[gsis] }
export function favCount() { return Object.keys(getFavs()).length }
export function favList() {
  const f = getFavs()
  return Object.entries(f).map(([gsis_id, v]) => ({ gsis_id, ...v }))
}

function _save(f) {
  try { localStorage.setItem(KEY, JSON.stringify(f)) } catch (_) {}
  try { window.dispatchEvent(new Event('brkr-favs')) } catch (_) {}   // let open views refresh
  _sync(f)
}

// Toggle a player. Accepts a row/player object; needs a gsis + name/team. Returns the new map.
export function toggleFav(p) {
  const id = p && (p.gsis_id || p.gsis)
  if (!id) return getFavs()
  const f = getFavs()
  if (f[id]) delete f[id]
  else f[id] = { name: p.full_name || p.name || '', team: p.team || '', pos: p.pos || p.position || '' }
  _save(f)
  return f
}

// Best-effort: mirror the favorites into the push watchlist so alerts fire. No-op without a push
// subscription (endpoint null) — favorites still live locally until the user turns alerts on.
async function _sync(f) {
  try {
    const ep = await getPushEndpoint()
    if (!ep) return
    const cur = await getNFLNotifyPrefs(ep)
    const prefs = (cur && cur.prefs) || {}
    const wl = prefs.watchlist || {}
    wl.players = Object.keys(f)
    wl.player_names = Object.values(f).map(v => v.name).filter(Boolean)
    wl.teams = wl.teams || []
    prefs.watchlist = wl
    await setNFLNotifyPrefs(ep, prefs)
  } catch (_) { /* non-fatal — local favorites are the source of truth */ }
}

// Call after the user enables push, so their existing favorites start firing alerts.
export function syncFavsNow() { _sync(getFavs()) }
